<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-content">
        <div class="footer-section company-section">
          <div class="footer-logo-wrapper">
            <!-- <img src="@/assets/logo.gif" alt="福建三体星云 LOGO" class="footer-logo" /> -->
            <img src="@/assets/logo_bottom.svg" alt="福建三体星云 LOGO" class="footer-logo" />
          </div>
          <div class="contact-section">
            <!-- <h4>联系方式</h4> -->
            <!-- <div class="contact-item">
              <span class="contact-label">服务邮箱：</span>
              <a href="mailto:Services@3Clouds.Cn" class="contact-link">Services@3Clouds.cn</a>
            </div> -->
            <!-- <div class="contact-item">
              <span class="contact-label">服务热线：</span>
              <a href="tel:4008-255-199" class="contact-link">4008-255-199</a>
            </div> -->
          <!-- <div class="contact-item">
            <span class="contact-label">地址：</span>
            <span class="contact-text">福州市鼓楼区乌山西路518号新能源科创中心9层01-3单元</span>
          </div> -->
          </div>
        </div>
        
        <div class="footer-section">
          <!-- <h4>导航</h4> -->
          <div class="footer-nav">
            <div v-for="nav in footerNav" :key="nav.title" class="nav-group">
              <p class="nav-level-one">{{ nav.title }}</p>
              <div class="nav-level-two-list">
                <div
                  v-for="child in nav.children"
                  :key="`${nav.title}-${child.label}`"
                  class="nav-level-two"
                >
                  <router-link :to="child.to" class="nav-link-text">{{ child.label }}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>

    </div>
      
      <div class="footer-bottom">
        <span>&copy; {{ currentYear }} 福建三体星云信息科技有限公司 版权所有 </span>
        <span> 不得转载 </span>
        <span class="gongan-logo-wrapper"><img src="@/assets/police.png" alt="公安备案" class="gongan-logo"></span>
        <span> <a href="https://beian.miit.gov.cn/" target="_blank" style="text-decoration: none;color: rgba(0, 0, 0, 0.7);">闽ICP备20000345号-1</a> </span>
        <span> 2025-2026</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      footerNav: [
        // {
        //   title: '网站首页',
        //   children: [{ label: '首页', to: '/' }]
        // },
        {
          title: '产品中心',
          children: [
            { label: '人工智能中心', to: '/products#big-data-platform' },
            { label: '应用中心', to: '/products#application-center' }
            // { label: '运营中心', to: '/products#operation-center' }
          ]
        },
        {
          title: 'IT业务',
          children: [
            { label: '全栈IT融合数据中心', to: '/it' },
            { label: 'IT智能运维', to: '/it' },
            { label: '智能协作', to: '/it' },
            { label: '数字能源', to: '/it' }
          ]
        },
        {
          title: '网络安全',
          children: [
            { label: '网络安全', to: '/security' },
            { label: '数据安全', to: '/security' },
            { label: '密码安全', to: '/security' },
            { label: '工控安全', to: '/security' },
            { label: '安全运营', to: '/security' }
          ]
        },
        {
          title: '新闻中心',
          children: [
            { label: '公司新闻', to: '/news#company-news' },
            { label: '行业新闻', to: '/news#industry-news' }
          ]
        },
        {
          title: '关于我们',
          children: [
            { label: '公司介绍', to: '/about#company-intro' },
            { label: '企业文化', to: '/about#culture' },
            // { label: '企业历程', to: '/about#timeline' },
            // { label: '荣誉资质', to: '/about#honors' },
            // { label: '客户案例', to: '/about#customers' },
            { label: '人才招聘', to: '/about#careers' },
            { label: '联系我们', to: '/about#contact-us' }
          ]
        }
      ]
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.footer {
  background: white;
  color: black;
  padding: 10px 0 10px;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: flex;
  justify-self: space-between;
  justify-content: space-between;
  padding: 20px;
  /* grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); */
  /* gap: 0px; */
  /* margin-bottom: 20px; */
}

.footer-section h3 {
  font-size: 24px;
  margin-bottom: 15px;
  color: black;
}

.company-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  justify-content: center;
}

.footer-logo-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.footer-logo {
  width: 150px;
  height: 110px;
  /* object-fit: contain; */
  border-radius: 12px;
}

.contact-section {
  width: 100%;
}

.footer-section h4 {
  font-size: 18px;
  margin-bottom: 20px;
  color: black;
  border-bottom: 2px solid rgba(0, 0, 0, 0.3);
  padding-bottom: 10px;
}

.contact-item {
  margin-bottom: 15px;
  display: flex;
  /* flex-wrap: wrap; */
  align-items: center;
}

.contact-label {
  color: rgba(0, 0, 0, 0.9);
  font-weight: 500;
  margin-right: 8px;
  min-width: 80px;
}

.contact-link {
  color: rgba(0, 0, 0, 0.8);
  text-decoration: none;
  transition: all 0.3s ease;
}

.contact-text {
  color: rgba(0, 0, 0, 0.8);
  line-height: 1.6;
  font-size: 14px;
}

.contact-link:hover {
  color: #333;
  text-decoration: underline;
}

.footer-nav {
  display: flex;
  gap: 5px;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: flex-start;
}

.nav-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 140px;
  flex: 1;
}

.nav-level-one {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.95);
}

.nav-level-two-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.nav-level-two {
  text-indent: 0;
}

.nav-link-text {
  color: rgba(0, 0, 0, 0.8);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
}

.nav-link-text:hover {
  color: #333;
  text-decoration: underline;
}

.address-item {
  margin-bottom: 20px;
}

.address-item strong {
  display: block;
  color: rgba(0, 0, 0, 0.95);
  margin-bottom: 5px;
  font-size: 14px;
}

.address-item p {
  color: rgba(0, 0, 0, 0.8);
  line-height: 1.6;
  font-size: 14px;
  margin: 0;
  padding-left: 10px;
}

.footer-bottom {
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  padding-top: 10px;
  text-align: center;
}

.footer-bottom span {
  color: rgba(0, 0, 0, 0.7);
  font-size: 12px;
  margin: 0;
}

.gongan-logo-wrapper {
  display: inline-block;
  width: 15px;
  height: 15px;
  vertical-align: middle;
}

.gongan-logo {
  width: 15px;
  height: 15px;
}

@media (max-width: 768px) {
  .footer {
    padding: 40px 0 20px;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .company-section {
    align-items: center;
    text-align: center;
  }

  .footer-logo-wrapper {
    display: flex;
    justify-content: center;
  }

  .contact-section {
    text-align: left;
    width: 100%;
  }

  .contact-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .contact-label {
    min-width: auto;
    margin-bottom: 5px;
  }

  .footer-nav {
    flex-direction: column;
    gap: 20px;
  }
}
</style>

